import type { departments as en } from '@/i18n/locales/en/departments';
import type { Translation } from '@/i18n/types';

export const departments: Translation<typeof en> = {
  page: {
    title: 'Reparti',
    leadPersonal: 'Reparti di cui sei membro.',
    leadCompany: 'Reparti in {{company}}.',
  },
  list: {
    cardTitle: 'Reparti',
    name: 'Nome',
    company: 'Azienda',
    statistics: 'Statistiche',
    collectiveConsent: 'Consenso collettivo',
    inForce: 'in vigore',
    none: '—',
    unattached: 'non assegnato',
    empty: 'Ancora nessun reparto qui.',
    newDepartment: 'Nuovo reparto',
  },
  compare: {
    cardTitle: 'Confronto tra reparti',
    pageTitle: 'Confronto tra reparti',
    lead: 'Confronto dei reparti di cui puoi vedere le statistiche.',
    empty: 'Nessun reparto qui ha statistiche che puoi vedere.',
  },
  detail: {
    thisDepartment: 'reparto',
    edit: 'Modifica',
    setVisibility: 'Imposta visibilità',
    collectiveConsent: 'Consenso collettivo',
    coach: 'Allenatore',
    category: 'Categoria',
    type: 'Tipo',
    statistics: 'Statistiche',
    notRecorded: 'non registrato',
    membersCardTitle: 'Membri',
    statsCardTitle: 'Statistiche',
    settingsCardTitle: 'Impostazioni',
    addPerson: 'Aggiungi persona',
    name: 'Nome',
    nickname: 'Soprannome',
    login: 'Accesso',
    yes: 'sì',
    no: 'no',
    noMembers: 'Nessun membro.',
  },
  form: {
    newTitle: 'Nuovo reparto',
    newLead:
      'Ogni nuovo reparto parte solo con dati aggregati — lo stato che tutela la privacy è quello che ottieni senza fare nulla.',
    name: 'Nome',
    category: 'Categoria',
    type: 'Tipo',
    cancel: 'Annulla',
    create: 'Crea reparto',
    editTitle: 'Modifica reparto',
    save: 'Salva',
    deleteCardTitle: 'Elimina',
    deleteButton: 'Elimina questo reparto',
    deleteConfirm: 'Eliminare {{name}} definitivamente?',
    deleteKeep: 'Mantienilo',
    deleteYes: 'Sì, elimina',
    visibilityTitle: 'Visibilità delle statistiche',
    visibilityLead:
      'individuale non espone nessuno di per sé: consente l’accesso individuale dove una base di consenso copre il membro. Passare a individuale senza un accordo collettivo crea una riga di consenso in sospeso per ogni membro attuale.',
    visibilityAggregate: 'aggregato — solo numeri di gruppo',
    visibilityIndividual: 'individuale — accesso per membro dove il consenso lo copre',
    collectiveConsentTitle: 'Base del consenso collettivo',
    collectiveConsentLead:
      'Finché un accordo collettivo è in vigore, copre tutti i membri di {{name}}, qualunque sia la loro risposta personale. Le righe personali dei membri vengono mantenute e tornano efficaci quando viene revocato.',
    collectiveConsentNote: 'Accordo esterno alla piattaforma (identificalo con precisione)',
    collectiveConsentRecord: 'Registra base collettiva',
    revokeCardTitle: 'Revoca',
    revokeButton: 'Revoca la base collettiva',
  },
};
